export default {
  'invoiceTransport.label.transport': 'Transport',
  'invoiceTransport.label.shippingCompany': 'Shipping Company',
  'invoiceTransport.label.shippingType': 'Shipping Type',
  'invoiceTransport.label.transportVehicle': 'Transport Vehicle',
  'invoiceTransport.label.licensePlate': 'License Plate',
  'invoiceTransport.label.uf': 'UF',
  'invoiceTransport.label.rntc': 'RNTC',
  'invoiceTransport.label.volumes': 'Volumes',
  'invoiceTransport.label.quantity': 'Quantity',
  'invoiceTransport.label.specie': 'Specie',
  'invoiceTransport.label.brand': 'Brand',
  'invoiceTransport.label.numbering': 'Numbering',
  'invoiceTransport.label.grossWeight': 'Gross Weight(kg)',
  'invoiceTransport.label.netWeight': 'Net Weight(kg)',

  'invoiceTransport.select.sender': '0 - On behalf of the issuer',
  'invoiceTransport.select.recipient': '1 - On behalf of the recipient/sender',
  'invoiceTransport.select.third': '2 - On behalf of third parties',
  'invoiceTransport.select.senderTransport':
    '3 - Own Transport on behalf of the Sender',
  'invoiceTransport.select.recipientTransport':
    '4 - Own Transport at the expense of the Recipient',
  'invoiceTransport.select.noTransport': '9 - No shipping',

  'invoiceTransport.dropdown.carrier': 'Carrier',
  'invoiceTransport.button.create': 'Create',
  'invoiceTransport.button.edit': 'Edit',

  'invoiceTransport.title.createCarrier': 'Create Carrier',
  'invoiceTransport.title.editCarrier': 'Edit Carrier',

  'invoiceTransport.modal.label.socialReason': 'Social Reason',
  'invoiceTransport.modal.label.stateRegistration': 'State Registration',
  'invoiceTransport.modal.label.personType': 'Person Type',
  'invoiceTransport.modal.label.physical': 'Physical',
  'invoiceTransport.modal.label.cpf': 'CPF',
  'invoiceTransport.modal.label.cnpj': 'CNPJ',
  'invoiceTransport.modal.label.zipCode': 'Zip Code',
  'invoiceTransport.modal.label.state': 'State',
  'invoiceTransport.modal.label.city': 'City',
  'invoiceTransport.modal.label.district': 'District',
  'invoiceTransport.modal.label.street': 'Street',
  'invoiceTransport.modal.label.number': 'Number',
  'invoiceTransport.modal.label.complement': 'Complement',
  'invoiceTransport.modal.label.comments': 'Comments',

  'invoiceTransport.modal.option.natural': 'Natural',
  'invoiceTransport.modal.option.legal': 'Legal',

  'invoiceTransport.notification.create.success.title':
    'Carrier registered successfully!',
  'invoiceTransport.notification.create.success.description':
    'The new carrier has been registered successfully.',

  'invoiceTransport.notification.remove.success.title':
    'Carrier removed successfully!',
  'invoiceTransport.notification.remove.success.description':
    'The carrier has been removed successfully.',

  'invoiceTransport.notification.update.success.title':
    'Carrier updated successfully!',
  'invoiceTransport.notification.update.success.description':
    'The carrier has been updated successfully.',
};
